import React, {Component, useState} from 'react';
import Toast from "react-bootstrap/Toast";
import Moment from 'react-moment';
import {connect} from "react-redux";


const Notification = (props)=>{
    const notif = props.notif
    let [showMe, setShowMe] = useState(true)
    const toggleShowMe = ()=> {
        setShowMe(!showMe);
        console.log(notif.notifiable_id)
        axios.get('/Api/user/notification/read/'+notif.id)
            .then(result => {
                console.log(result)
                props.readNotification()
            }).catch(err => {
            console.log(err)
        })
    }

        return (
            <Toast   className={'bg-dark shadow'} show={showMe} onClose={toggleShowMe}>
                <Toast.Header  className={''}>
                            <span className="badge badge-primary rounded-pill " >
                            <i className="far fa-bell eu-btn-icon mr-auto" style={{'fontSize': '0.65rem'}}></i>
                        </span>
                    <strong className="ml-2 mr-auto">{notif.data.context}</strong>
                    <small className={'d-flex align-self-end'}>
                        <Moment fromNow locale="fr">
                            {notif.created_at}
                        </Moment>
                    </small>
                </Toast.Header>
                <Toast.Body>
                    <h5 className={'text-primary'}>{notif.data.title}</h5>
                    <p className={'font-italic'}>{notif.data.message}</p>
                </Toast.Body>
            </Toast>
        );
}


const mapStateToProps = state => {
    return {
        unreadNb: state.notificationsCounter
    }
}

const mapDispatchToProps = dispatch => {
    return {
        readNotification: ()=>dispatch({type: 'READ_NOTIFICATION'}),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
